import {
  queryTicketDefinitions as publicQueryTicketDefinitions,
  queryTicketDefinitionsV2 as publicQueryTicketDefinitionsV2,
  typedQueryTicketDefinitionsV2 as publicTypedQueryTicketDefinitionsV2,
  listTicketDefinitions as publicListTicketDefinitions,
  getTicketDefinition as publicGetTicketDefinition,
  createTicketDefinition as publicCreateTicketDefinition,
  updateTicketDefinition as publicUpdateTicketDefinition,
  deleteTicketDefinition as publicDeleteTicketDefinition,
  changeCurrency as publicChangeCurrency,
} from './events-v1-ticket-definition-ticket-definitions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  DefinitionsQueryBuilder,
  QueryTicketDefinitionsV2Options,
  TicketDefinitionQuery,
  typedQueryTicketDefinitionsV2 as universalTypedQueryTicketDefinitionsV2,
} from './events-v1-ticket-definition-ticket-definitions.universal.js';
import { onTicketDefinitionCreated as publicOnTicketDefinitionCreated } from './events-v1-ticket-definition-ticket-definitions.public.js';
import { onTicketDefinitionDeleted as publicOnTicketDefinitionDeleted } from './events-v1-ticket-definition-ticket-definitions.public.js';
import { onTicketDefinitionUpdated as publicOnTicketDefinitionUpdated } from './events-v1-ticket-definition-ticket-definitions.public.js';

function customQueryTicketDefinitionsV2(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryTicketDefinitionsV2Options) =>
      publicQueryTicketDefinitionsV2(httpClient)(options),
    typedQueryFunction: (
      query: TicketDefinitionQuery,
      options?: QueryTicketDefinitionsV2Options
    ) => publicTypedQueryTicketDefinitionsV2(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: TicketDefinitionQuery,
    options?: QueryTicketDefinitionsV2Options
  ): ReturnType<typeof universalTypedQueryTicketDefinitionsV2>;
  function overloadedQuery(
    options?: QueryTicketDefinitionsV2Options
  ): DefinitionsQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: TicketDefinitionQuery | QueryTicketDefinitionsV2Options,
    options?: QueryTicketDefinitionsV2Options
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const queryTicketDefinitions: MaybeContext<
  BuildRESTFunction<typeof publicQueryTicketDefinitions> &
    typeof publicQueryTicketDefinitions
> = /*#__PURE__*/ createRESTModule(publicQueryTicketDefinitions);
export const listTicketDefinitions: MaybeContext<
  BuildRESTFunction<typeof publicListTicketDefinitions> &
    typeof publicListTicketDefinitions
> = /*#__PURE__*/ createRESTModule(publicListTicketDefinitions);
export const getTicketDefinition: MaybeContext<
  BuildRESTFunction<typeof publicGetTicketDefinition> &
    typeof publicGetTicketDefinition
> = /*#__PURE__*/ createRESTModule(publicGetTicketDefinition);
export const createTicketDefinition: MaybeContext<
  BuildRESTFunction<typeof publicCreateTicketDefinition> &
    typeof publicCreateTicketDefinition
> = /*#__PURE__*/ createRESTModule(publicCreateTicketDefinition);
export const updateTicketDefinition: MaybeContext<
  BuildRESTFunction<typeof publicUpdateTicketDefinition> &
    typeof publicUpdateTicketDefinition
> = /*#__PURE__*/ createRESTModule(publicUpdateTicketDefinition);
export const deleteTicketDefinition: MaybeContext<
  BuildRESTFunction<typeof publicDeleteTicketDefinition> &
    typeof publicDeleteTicketDefinition
> = /*#__PURE__*/ createRESTModule(publicDeleteTicketDefinition);
export const changeCurrency: MaybeContext<
  BuildRESTFunction<typeof publicChangeCurrency> & typeof publicChangeCurrency
> = /*#__PURE__*/ createRESTModule(publicChangeCurrency);
export const queryTicketDefinitionsV2: MaybeContext<
  BuildRESTFunction<typeof customQueryTicketDefinitionsV2> &
    typeof customQueryTicketDefinitionsV2
> = /*#__PURE__*/ createRESTModule(customQueryTicketDefinitionsV2);
/** */
export const onTicketDefinitionCreated: BuildEventDefinition<
  typeof publicOnTicketDefinitionCreated
> &
  typeof publicOnTicketDefinitionCreated = createEventModule(
  publicOnTicketDefinitionCreated
);
/** */
export const onTicketDefinitionDeleted: BuildEventDefinition<
  typeof publicOnTicketDefinitionDeleted
> &
  typeof publicOnTicketDefinitionDeleted = createEventModule(
  publicOnTicketDefinitionDeleted
);
/** */
export const onTicketDefinitionUpdated: BuildEventDefinition<
  typeof publicOnTicketDefinitionUpdated
> &
  typeof publicOnTicketDefinitionUpdated = createEventModule(
  publicOnTicketDefinitionUpdated
);

export {
  FeeType,
  TicketSaleStatus,
  TicketDefinitionStateEnumState,
  Type,
  TicketDefinitionFieldset,
  SortOrder,
  State,
  GroupBy,
  WebhookIdentityType,
} from './events-v1-ticket-definition-ticket-definitions.universal.js';
export {
  TicketDefinition,
  Money,
  Dashboard,
  WixFeeConfig,
  TicketSalePeriod,
  TicketPricing,
  TicketPricingPriceOneOf,
  PricingOptions,
  PricingOption,
  QueryTicketDefinitionsRequest,
  QueryTicketDefinitionsResponse,
  FacetCounts,
  QueryTicketDefinitionsV2Request,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryTicketDefinitionsV2Response,
  PagingMetadataV2,
  Cursors,
  ListTicketDefinitionsRequest,
  ListTicketDefinitionsResponse,
  ResponseMetaData,
  GetTicketDefinitionRequest,
  GetTicketDefinitionResponse,
  CreateTicketDefinitionRequest,
  TicketDefinitionData,
  CreateTicketDefinitionResponse,
  TicketDefinitionCreated,
  OriginatedFrom,
  UpdateTicketDefinitionRequest,
  UpdateTicketDefinitionResponse,
  TicketDefinitionUpdated,
  DeleteTicketDefinitionRequest,
  DeleteTicketDefinitionRequestDeleteOneOf,
  ById,
  DeleteTicketDefinitionResponse,
  TicketDefinitionDeleted,
  ChangeCurrencyRequest,
  ChangeCurrencyResponse,
  BulkCopyTicketDefinitionsByEventIdRequest,
  BulkCopyTicketDefinitionsByEventIdResponse,
  CopiedTicketDefinition,
  PaidTicketDefinitionExistsRequest,
  PaidTicketDefinitionExistsResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  TicketDefinitionCreatedEnvelope,
  TicketDefinitionDeletedEnvelope,
  TicketDefinitionUpdatedEnvelope,
  QueryTicketDefinitionsOptions,
  QueryTicketDefinitionsV2Options,
  DefinitionsQueryResult,
  DefinitionsQueryBuilder,
  TicketDefinitionQuerySpec,
  ListTicketDefinitionsOptions,
  GetTicketDefinitionOptions,
  CreateTicketDefinitionOptions,
  UpdateTicketDefinitionOptions,
  DeleteTicketDefinitionOptions,
  DeleteTicketDefinitionOptionsDeleteOneOf,
  ChangeCurrencyOptions,
} from './events-v1-ticket-definition-ticket-definitions.universal.js';
export { utils } from './events-v1-ticket-definition-ticket-definitions.universal.js';
export {
  FeeTypeWithLiterals,
  TicketSaleStatusWithLiterals,
  TicketDefinitionStateEnumStateWithLiterals,
  TypeWithLiterals,
  TicketDefinitionFieldsetWithLiterals,
  SortOrderWithLiterals,
  StateWithLiterals,
  GroupByWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  TicketDefinitionQuery,
} from './events-v1-ticket-definition-ticket-definitions.universal.js';
